import { styled, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { BanksComparisonTable } from '../BanksComparisonTable';
import { Link } from '../Link';

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const BanksComparisonTableMaxWidth = styled(BanksComparisonTable)({
  maxWidth: '1280px',
});

const TypographyStyled = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(5),
  marginBottom: theme.spacing(5),
  maxWidth: '1280px',
  textAlign: 'center',
}));

const ExplanationsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  maxWidth: '1280px',
  marginTop: theme.spacing(5),
  marginBottom: theme.spacing(5),
  color: '#6C7889',
  '& > :not(style)': {
    marginBottom: theme.spacing(2),
  },
}));

const BANKS_IN_ORDER = ['comdirect', 'ebase', 'fondsdepotbank', 'dab', 'ffb'];

export interface BankInfoProps {
  bankSlug: string;
  title: string;
  children?: ReactNode;
  calculatorUrl?: string;
}

export const BankInfo = ({ bankSlug, title, children, calculatorUrl = '/' }: BankInfoProps) => {
  const { t } = useTranslation();

  const banks = [bankSlug, ...BANKS_IN_ORDER.filter((slug) => slug !== bankSlug)].slice(0, 3);
  return (
    <Container>
      <TypographyStyled variant="h1">{title}</TypographyStyled>
      {children}
      <BanksComparisonTableMaxWidth defaultBanks={banks} />
      <ExplanationsContainer>
        <Typography>{t('banksComparisonTable.explanations.line1')}</Typography>
        <Typography>
          <Trans i18nKey="banksComparisonTable.explanations.line2">
            Bei Fonds der Union Investment und der Deka Investment können Ausgabeaufschläge
            anfallen, da diese Gesellschaften die Rabattierung u.U. verhindern. Nutzen Sie unseren
            <Link href={calculatorUrl}>Detailrechner</Link>, um diese Fonds zu erkennen.
          </Trans>
        </Typography>
        <Typography>{t('banksComparisonTable.explanations.line3')}</Typography>
        <Typography>{t('banksComparisonTable.explanations.line4')}</Typography>
      </ExplanationsContainer>
    </Container>
  );
};
